import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationContext } from './shared/services/authentication/authentication-context';
import { AliveService } from '@ui/global-shared/services';
import { environment } from '../environments/environment';
import { CalendarLocalizationService } from '@ui/global-shared/util/calendar-localization.service';
import { PrimeNG } from 'primeng/config';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { MultiLoginDetectedComponent } from './multi-login-detected/multi-login-detected.component';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'pt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, MultiLoginDetectedComponent, Bind, Toast, AsyncPipe],
})
export class AppComponent {
  private authContext = inject(AuthenticationContext);
  private aliveService = inject(AliveService);

  loggedIn = false;
  readonly loggedInUserChanged$ = this.aliveService.loggedInUserChanged$;

  constructor() {
    const aliveService = this.aliveService;
    const config = inject(PrimeNG);
    const calendarLocalizationService = inject(CalendarLocalizationService);

    aliveService.configureInterval(environment.keepAliveInterval);

    this.authContext.getUserInformation().subscribe((credentials) => {
      this.loggedIn = !!credentials;
    });

    config.setTranslation(calendarLocalizationService.getLang());
  }
}
